import { CaDialogComponent } from '../../../../shared/dialogs/ca-dialog.base'
import { AttachmentRouteTypeEnum } from '../../enums/attachment-route-type.enum'
import { Component, Inject } from '@angular/core'
import { AttachmentService } from '../../services/attachment.service'
import { DialogService } from '../../../../core/services/dialog.service'
import { ErrorService } from '../../../../core/services/error.service'
import _ from 'lodash'

@Component({
    selector: 'ca-add-link-attachment-dialog',
    templateUrl: './add-link-attachment-dialog.html',
    standalone: false
})
export class AddLinkAttachmentDialogComponent extends CaDialogComponent<{
    entityId: number;
    name: string;
    routeType: AttachmentRouteTypeEnum;
    url: string;
}, boolean> {

    entityId: number
    name: string
    routeType: AttachmentRouteTypeEnum
    url: string
    loading = false

    constructor(@Inject(AttachmentService) private attachmentService: AttachmentService,
                @Inject(DialogService) private dialogService: DialogService,
                @Inject(ErrorService) private errorService: ErrorService
                ) {
        super()
    }

    save(): void {
        if (this.validateForm()) {
            this.loading = true
            this.attachmentService
                    .saveLinkAttachment(this.name, this.url, this.entityId, this.routeType)
                    .then(() => {
                            super.result = true
                            super.close()
                        }, (error) => {
                                this.errorService
                                    .onErrorResponseAlertUser(error, 'Při ukládání odkazu došlo k chybě.')
                                    .then(() => {
                                        super.result = false
                                        super.close()
                                    })
                            })
        } else {
            this.dialogService
                    .showWarningDialog('Je třeba zadat název a URL odkazu, název může mít maximálně 255 znaků.')
        }
    }

    validateForm(): boolean {
        if (!this.name || !this.url) {
            return false
        }

        if (_.size(this.name) > 255) {
            return false
        }

        return true
    }
}
